module.exports = __webpack_public_path__ + "static/media/btn-pay-credit-card.d68a8d36.png";